import { z } from "zod";

import { MetaDataSchema } from "@/schemas/meta-data";

export const SubsectionSchema = z.object({
	order: z.number().min(1),
	header: z.string().min(1, { message: "Header is required" }),
	instruction: z.string().min(1, { message: "Instruction is required" }),
});

export const SectionSchema = z.object({
	order: z.number().min(1),
	header: z.string().min(1, { message: "Header is required" }),
	instruction: z.string().min(1, { message: "Instruction is required" }),
	subsections: z.array(SubsectionSchema).optional(),
});

export const PromptContentSchema = z.object({
	template_name: z.string().optional(),
	client_name: z.string().optional(),
	sections: z.array(SectionSchema).min(1, { message: "At least one section is required" }),
});

export const DeepResearchPromptSchema = z.object({
	id: z.number(),
	companyId: z.number().optional(),
	name: z.string(),
	prompt: PromptContentSchema,
	strongFitPrompt: z.string().nullable().optional(),
	mediumFitPrompt: z.string().nullable().optional(),
	weakFitPrompt: z.string().nullable().optional(),
	language: z.string().nullable().optional(),
	createdAt: z.string().optional(),
	updatedAt: z.string().optional(),
});

export const CreateDeepResearchPromptSchema = z.object({
	name: z.string().min(1, { message: "Name is required" }),
	prompt: PromptContentSchema,
	strongFitPrompt: z.string().nullable().optional(),
	mediumFitPrompt: z.string().nullable().optional(),
	weakFitPrompt: z.string().nullable().optional(),
	language: z.string().nullable().optional(),
});

export const UpdateDeepResearchPromptSchema = z.object({
	id: z.number(),
	name: z.string().min(1, { message: "Name is required" }).optional(),
	prompt: PromptContentSchema.optional(),
	strongFitPrompt: z.string().nullable().optional(),
	mediumFitPrompt: z.string().nullable().optional(),
	weakFitPrompt: z.string().nullable().optional(),
	language: z.string().nullable().optional(),
});

export const DeepResearchPromptResponseSchema = z.object({
	data: z.array(DeepResearchPromptSchema),
	meta: MetaDataSchema,
});

export type Subsection = z.infer<typeof SubsectionSchema>;
export type Section = z.infer<typeof SectionSchema>;
export type PromptContent = z.infer<typeof PromptContentSchema>;
export type DeepResearchPrompt = z.infer<typeof DeepResearchPromptSchema>;
export type CreateDeepResearchPrompt = z.infer<typeof CreateDeepResearchPromptSchema>;
export type UpdateDeepResearchPrompt = z.infer<typeof UpdateDeepResearchPromptSchema>;
export type DeepResearchPromptResponse = z.infer<typeof DeepResearchPromptResponseSchema>;
